/* tslint:disable */
import {
  Account,
  CountryCode,
  Contact,
  Jobsite,
  Project,
  StateManager,
  MyWorkLeaveEntitlementSetting
} from '../index';

declare var Object: any;
export interface MyWorkLeaveTypeSettingInterface {
  "sfdcId"?: string;
  "OwnerId"?: string;
  "IsDeleted"?: boolean;
  "Name"?: string;
  "CreatedById"?: string;
  "CreatedDate"?: Date;
  "CurrencyIsoCode"?: string;
  "LastModifiedDate"?: Date;
  "LastModifiedById"?: string;
  "LastActivityDate"?: Date;
  "LastViewedDate"?: Date;
  "LastReferencedDate"?: Date;
  "Account__c"?: string;
  "Active__c"?: boolean;
  "Allowed_To_Accumulate__c"?: boolean;
  "Country_Code__c"?: string;
  "Created_By_Contact__c"?: string;
  "Default__c"?: boolean;
  "Group__c"?: string;
  "IRON_ExtID__c"?: string;
  "Jobsite__c"?: string;
  "Leave_Code__c"?: string;
  "Leave_Icon__c"?: string;
  "Leave_Icon1__c"?: string;
  "Leave_Name__c"?: string;
  "Leave_Type__c"?: string;
  "Modified_By_Contact__c"?: string;
  "PgMO_Departments__c"?: string;
  "Program__c"?: string;
  "State__c"?: string;
  "Unit__c"?: string;
  "Worker_Billing_Type__c"?: string;
  "Worker_Type__c"?: string;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
  account?: Account;
  countryCode?: CountryCode;
  contact?: Contact;
  jobsite?: Jobsite;
  modifiedByContact?: Contact;
  project?: Project;
  stateManager?: StateManager;
  myWorkLeaveEntitlementSettings?: MyWorkLeaveEntitlementSetting[];
}

export class MyWorkLeaveTypeSetting implements MyWorkLeaveTypeSettingInterface {
  "sfdcId": string;
  "OwnerId": string;
  "IsDeleted": boolean;
  "Name": string;
  "CreatedById": string;
  "CreatedDate": Date;
  "CurrencyIsoCode": string;
  "LastModifiedDate": Date;
  "LastModifiedById": string;
  "LastActivityDate": Date;
  "LastViewedDate": Date;
  "LastReferencedDate": Date;
  "Account__c": string;
  "Active__c": boolean;
  "Allowed_To_Accumulate__c": boolean;
  "Country_Code__c": string;
  "Created_By_Contact__c": string;
  "Default__c": boolean;
  "Group__c": string;
  "IRON_ExtID__c": string;
  "Jobsite__c": string;
  "Leave_Code__c": string;
  "Leave_Icon__c": string;
  "Leave_Icon1__c": string;
  "Leave_Name__c": string;
  "Leave_Type__c": string;
  "Modified_By_Contact__c": string;
  "PgMO_Departments__c": string;
  "Program__c": string;
  "State__c": string;
  "Unit__c": string;
  "Worker_Billing_Type__c": string;
  "Worker_Type__c": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  account: Account;
  countryCode: CountryCode;
  contact: Contact;
  jobsite: Jobsite;
  modifiedByContact: Contact;
  project: Project;
  stateManager: StateManager;
  myWorkLeaveEntitlementSettings: MyWorkLeaveEntitlementSetting[];
  constructor(data?: MyWorkLeaveTypeSettingInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `MyWorkLeaveTypeSetting`.
   */
  public static getModelName() {
    return "MyWorkLeaveTypeSetting";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of MyWorkLeaveTypeSetting for dynamic purposes.
  **/
  public static factory(data: MyWorkLeaveTypeSettingInterface): MyWorkLeaveTypeSetting{
    return new MyWorkLeaveTypeSetting(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'MyWorkLeaveTypeSetting',
      plural: 'MyWorkLeaveTypeSettings',
      path: 'MyWorkLeaveTypeSettings',
      idName: 'id',
      properties: {
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "OwnerId": {
          name: 'OwnerId',
          type: 'string'
        },
        "IsDeleted": {
          name: 'IsDeleted',
          type: 'boolean'
        },
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "CreatedById": {
          name: 'CreatedById',
          type: 'string'
        },
        "CreatedDate": {
          name: 'CreatedDate',
          type: 'Date'
        },
        "CurrencyIsoCode": {
          name: 'CurrencyIsoCode',
          type: 'string'
        },
        "LastModifiedDate": {
          name: 'LastModifiedDate',
          type: 'Date'
        },
        "LastModifiedById": {
          name: 'LastModifiedById',
          type: 'string'
        },
        "LastActivityDate": {
          name: 'LastActivityDate',
          type: 'Date'
        },
        "LastViewedDate": {
          name: 'LastViewedDate',
          type: 'Date'
        },
        "LastReferencedDate": {
          name: 'LastReferencedDate',
          type: 'Date'
        },
        "Account__c": {
          name: 'Account__c',
          type: 'string'
        },
        "Active__c": {
          name: 'Active__c',
          type: 'boolean'
        },
        "Allowed_To_Accumulate__c": {
          name: 'Allowed_To_Accumulate__c',
          type: 'boolean'
        },
        "Country_Code__c": {
          name: 'Country_Code__c',
          type: 'string'
        },
        "Created_By_Contact__c": {
          name: 'Created_By_Contact__c',
          type: 'string'
        },
        "Default__c": {
          name: 'Default__c',
          type: 'boolean'
        },
        "Group__c": {
          name: 'Group__c',
          type: 'string'
        },
        "IRON_ExtID__c": {
          name: 'IRON_ExtID__c',
          type: 'string'
        },
        "Jobsite__c": {
          name: 'Jobsite__c',
          type: 'string'
        },
        "Leave_Code__c": {
          name: 'Leave_Code__c',
          type: 'string'
        },
        "Leave_Icon__c": {
          name: 'Leave_Icon__c',
          type: 'string'
        },
        "Leave_Icon1__c": {
          name: 'Leave_Icon1__c',
          type: 'string'
        },
        "Leave_Name__c": {
          name: 'Leave_Name__c',
          type: 'string'
        },
        "Leave_Type__c": {
          name: 'Leave_Type__c',
          type: 'string'
        },
        "Modified_By_Contact__c": {
          name: 'Modified_By_Contact__c',
          type: 'string'
        },
        "PgMO_Departments__c": {
          name: 'PgMO_Departments__c',
          type: 'string'
        },
        "Program__c": {
          name: 'Program__c',
          type: 'string'
        },
        "State__c": {
          name: 'State__c',
          type: 'string'
        },
        "Unit__c": {
          name: 'Unit__c',
          type: 'string'
        },
        "Worker_Billing_Type__c": {
          name: 'Worker_Billing_Type__c',
          type: 'string'
        },
        "Worker_Type__c": {
          name: 'Worker_Type__c',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        account: {
          name: 'account',
          type: 'Account',
          model: 'Account',
          relationType: 'belongsTo',
                  keyFrom: 'Account__c',
          keyTo: 'sfdcId'
        },
        countryCode: {
          name: 'countryCode',
          type: 'CountryCode',
          model: 'CountryCode',
          relationType: 'belongsTo',
                  keyFrom: 'Country_Code__c',
          keyTo: 'sfdcId'
        },
        contact: {
          name: 'contact',
          type: 'Contact',
          model: 'Contact',
          relationType: 'belongsTo',
                  keyFrom: 'Created_By_Contact__c',
          keyTo: 'sfdcId'
        },
        jobsite: {
          name: 'jobsite',
          type: 'Jobsite',
          model: 'Jobsite',
          relationType: 'belongsTo',
                  keyFrom: 'Jobsite__c',
          keyTo: 'sfdcId'
        },
        modifiedByContact: {
          name: 'modifiedByContact',
          type: 'Contact',
          model: 'Contact',
          relationType: 'belongsTo',
                  keyFrom: 'Modified_By_Contact__c',
          keyTo: 'sfdcId'
        },
        project: {
          name: 'project',
          type: 'Project',
          model: 'Project',
          relationType: 'belongsTo',
                  keyFrom: 'Program__c',
          keyTo: 'sfdcId'
        },
        stateManager: {
          name: 'stateManager',
          type: 'StateManager',
          model: 'StateManager',
          relationType: 'belongsTo',
                  keyFrom: 'State__c',
          keyTo: 'sfdcId'
        },
        myWorkLeaveEntitlementSettings: {
          name: 'myWorkLeaveEntitlementSettings',
          type: 'MyWorkLeaveEntitlementSetting[]',
          model: 'MyWorkLeaveEntitlementSetting',
          relationType: 'hasMany',
                  keyFrom: 'sfdcId',
          keyTo: 'MyWorkLeave_Type_Setting__c'
        },
      }
    }
  }
}
